export default class InfoDocService {
  // TODO: revisit for defining some type of content management
  _docEntries = {
    "Quick Base": {
      "CUSTOM_CSS": {
        content: "<p>Enables you add css styles to your template. Click the Help Icon to learn more.</p>",
        link: "https://formengine.freshdesk.com/a/solutions/articles/70000654451",
        placement: "top"
      },
      "TEMPLATE_LINKS": { 
        content: "<p><span class='highlight-tooltip'>Preview Form button:</span> opens the blank/Add Record version of your form in a new window.<br/><span class='highlight-tooltip'>Copy URL button:</span> copies the same version of the form to your clipboard.<br/>The <span class='highlight-tooltip'>QR code</span> renders the form on any mobile device using the device's camera. Click the Help Icon to learn more about QR Codes.</p>",
        link: "https://formengine.freshdesk.com/support/solutions/articles/70000395938-intro-to-working-with-qr-codes",
        placement: "bottom"
      },
      "PUBLISH_TEMPLATE_LINKS": {
        content: "<p>These links create Formula URL fields/buttons in your Quickbase app for this form for these purposes:<br/>1. <span class='highlight-tooltip'>Edit:</span> creates a button in your target table to edit any record in this form.<br/>2. <span class='highlight-tooltip'>Print:</span> creates a button in your target table for displaying any record in this form for read-only (View/Print/Download a PDF--like Exact Forms).<br/>3. <span class='highlight-tooltip'>Prefill:</span> creates a button in your target table for this form to be pre-filled with data from any existing record, and create a <span class='highlight-tooltip'>new</span> record when your users complete and submit the form.</p>",
        link: "https://formengine.freshdesk.com/a/solutions/articles/70000584668",
        placement: "bottom"
      },
      "PUBLISH_TEMPLATE_SINGED_LINKS": {
        content: "<p>Create new Smart Links to use your form template in many different ways. And Manage all the links you create for this template from here.</p>",
        link: "https://formengine.freshdesk.com/support/solutions/articles/70000684873-creating-a-signed-link",
        placement: "bottom"
      },
      "PUBLISH_GEN_TRIGGERS": {
        content: "<p>Create webhooks to automate these functions (and click the help icon for more detail):<br/><span class='highlight-tooltip'>Generate PDF:</span> auto-generates and attaches PDF/PPTX/DOCX output files for records in this form's format, from the webhook trigger that you configure.<br/><span class='highlight-tooltip'>Parse PDF:</span> Parses data out of populated PDFs and creates new QB records with the mapped data and PDF attached.</p>",
        link: "https://formengine.freshdesk.com/support/solutions/articles/70000585839-generate-pdf-api",
        placement: "top"
      },
      "PUBLISH_AUTH_TOOLS": {
        content: "<p>Enables you to create a QB dashboard button that takes your Form Engine builders into the Form Engine from QB without needing to log in. Click the Help Icon to learn more.</p>",
        link: "https://formengine.freshdesk.com/support/solutions/articles/70000584580-magic-authentication-link",
        placement: "top"
      },
      "UPLOAD_FIELD": {
        content: "<p>If you want a PDF, Word, or PowerPoint copy of this form saved each time this form is used, choose a file attachment field in your app to hold those auto-generated copies.If you don't have a file attachment field in your target table to use, create one in your app. Then refresh this browser, and it will display that file to choose.</p>",
        link: "https://formengine.freshdesk.com/support/solutions/articles/70000584580-magic-authentication-link",
        placement: "bottom"
      }
    }
  }

  constructor() {}

  getEntry(provider, key) {
    return this._docEntries[provider][key];
  }
}